import { HttpClient } from '@angular/common/http';
import { cmsApi } from '../constants/constants';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
var InvestmentPlanDataService = /** @class */ (function () {
    function InvestmentPlanDataService(http) {
        this.http = http;
    }
    // getMaintain
    InvestmentPlanDataService.prototype.getWebServiceInflation = function () {
        var URL = cmsApi + '/getInflation';
        var body = {};
        return this.http.post(URL, body);
    };
    InvestmentPlanDataService.prototype.getWebserviceProvident = function () {
        var URL = cmsApi + '/getProvident';
        var body = {};
        return this.http.post(URL, body);
    };
    InvestmentPlanDataService.prototype.getWebserviceSD = function () {
        var URL = cmsApi + '/getSD';
        var body = {};
        return this.http.post(URL, body);
    };
    InvestmentPlanDataService.prototype.getWebserviceExpectedReturn = function () {
        var URL = cmsApi + '/getExpected';
        var body = {};
        return this.http.post(URL, body);
    };
    InvestmentPlanDataService.prototype.getWebserviceDrawDown = function () {
        var URL = cmsApi + '/getDrawDown';
        var body = {};
        return this.http.post(URL, body);
    };
    InvestmentPlanDataService.prototype.getWebserviceInvestAlloName = function () {
        var URL = cmsApi + '/getInvestMent_Allo_name';
        var body = {};
        return this.http.post(URL, body);
    };
    InvestmentPlanDataService.prototype.getWebserviceInvestmentAllo = function () {
        var URL = cmsApi + '/getInvestMent_Allo';
        var body = {};
        return this.http.post(URL, body);
    };
    InvestmentPlanDataService.prototype.getInvestmentMapp = function (fundtypeId) {
        var URL = cmsApi + '/getInvestMent_mapping';
        var body = { fundType_id: fundtypeId };
        // console.log("getInvestmentMapp ", body);
        return this.http.post(URL, body);
    };
    InvestmentPlanDataService.ngInjectableDef = i0.defineInjectable({ factory: function InvestmentPlanDataService_Factory() { return new InvestmentPlanDataService(i0.inject(i1.HttpClient)); }, token: InvestmentPlanDataService, providedIn: "root" });
    return InvestmentPlanDataService;
}());
export { InvestmentPlanDataService };
